import { gql } from "@/__generated__/gql";

export const ORGANIZATION_DETAILS = gql(`
  query OrganizationDetails($id: ID!) {
    node(id: $id) {
      ... on Organization {
        id
        uuid
        name
        logo {
          id
          url(size: 24)
        }
        seatsAvailable
      }
    }
  }
`);
